import React from 'react';

import { PesoGramasInput } from '../../Components/Inputs';
import { DialogoCreateEdit } from '../../Components/modulo-gerencial-dialogos';
import { TextInput } from '../../Components/modulo-gerencial-formularios';
import ControllerInput from '../../Components/modulo-gerencial-formularios/inputs/ControllerInput';

const initialValues = {
  nome: '',
  valor: 0,
};

const validadores = {
  nome: (value) => {
    if (!value || value.length < 1) return 'Este campo é obrigatório';
    if (value.length > 20) return 'Não pode ser maior que 20 caracteres';
    return '';
  },
  valor: (value) => {
    const num = parseFloat(value);
    if (Number.isNaN(num)) return 'Valor inválido';
    if (num < 0) return 'Não pode ser negativo';
    return '';
  },
};

const transformGetDados = (dados) => ({
  nome: dados.nome,
  valor: dados.valor,
});

const transformSalvar = (dados) => ({
  nome: dados.nome,
  valor: parseFloat(dados.valor) || 0,
});

function Form() {
  return (
    <div>
      <TextInput name="nome" fullWidth label="Descrição" autoFocus />
      <ControllerInput
        name="valor"
        render={({ field }) => (
          <PesoGramasInput {...field} fullWidth label="Valor Tara" />
        )}
      />
    </div>
  );
}

const Dialogo = ({ onClose, open, id, isDialogoConfirmacaoActions }) => (
  <DialogoCreateEdit
    open={open}
    id={id}
    initialValues={initialValues}
    validators={validadores}
    resource="taras_balanca"
    titleCreate="Nova Tara de Balança"
    titleUpdate="Editar Tara de Balança"
    onClose={onClose}
    transformGetDados={transformGetDados}
    transformSalvar={transformSalvar}
    isCloseTitle
    isDialogoConfirmacaoActions={isDialogoConfirmacaoActions}
  >
    <Form />
  </DialogoCreateEdit>
);

export default Dialogo;
